export default __webpack_public_path__ + "static/media/Setting.34f86fca.svg";